import { ApiResponse, getFromServer, BASE_URL } from "server";
import { GetFileDetailsOutput } from "../OutputsTypes";
import { GetFileDetailsInput } from "../InputsTypes";

// Route : GET /files/:fileId
export const getFileDetails = async (
  fileId: string,
): Promise<ApiResponse<GetFileDetailsOutput>> => {
  return await getFromServer<GetFileDetailsOutput>(`/files/${fileId}`);
};

export const downloadFile = async (fileId: string): Promise<Blob> => {
  const response = await fetch(`${BASE_URL}/files/${fileId}/download`, {
    credentials: "include",
  });

  if (response.ok) {
    return await response.blob();
  } else {
    throw new Error("An error occurred.");
  }
};
